module.exports = {
      id: "reddit-plain-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#reddit-plain-color",
      toString: function () {
        return this.url;
      }
    }